import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon, QuoteIcon, UsersIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { SectionHeading } from './SectionHeading';
import { testimonials } from './data';
// Distinct color per avatar so each testimonial pops to the eye.
const avatarStyles = ['bg-cyan-500/15 text-cyan-300 ring-cyan-400/40', 'bg-violet-500/15 text-violet-300 ring-violet-400/40', 'bg-emerald-500/15 text-emerald-300 ring-emerald-400/40', 'bg-amber-500/15 text-amber-300 ring-amber-400/40', 'bg-rose-500/15 text-rose-300 ring-rose-400/40', 'bg-sky-500/15 text-sky-300 ring-sky-400/40'];
function Stars({
  className = ''
}: {
  className?: string;
}) {
  return <div className={`flex items-center gap-0.5 ${className}`} aria-label="5 de 5 estrellas" data-id="element-232">
      {Array.from({
      length: 5
    }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-accent text-accent" aria-hidden="true" data-id="element-233" />)}
    </div>;
}
export function Testimonials() {
  return <section className="relative w-full overflow-hidden bg-ink-950 py-12 sm:py-16" data-id="element-234">
      <div className="absolute inset-0 bg-radial-cyan-soft opacity-60" aria-hidden="true" data-id="element-235" />
      <div className="relative mx-auto max-w-6xl px-5" data-id="element-236">
        <SectionHeading eyebrow="Resultados Reales" data-id="element-237">
          +2,400 creadores ya están ejecutando con esto
        </SectionHeading>

        <Reveal delay={0.05} data-id="element-238">
          <p className="mx-auto mt-4 max-w-2xl text-center text-sm text-silver/70 sm:text-base" data-id="element-239">
            Estos son resultados reales de los primeros usuarios del ecosistema
            Nano-Creative.
          </p>
        </Reveal>

        {/* Rating + count summary */}
        <Reveal delay={0.1} data-id="element-240">
          <div className="mx-auto mt-8 flex max-w-xl flex-col items-center justify-center gap-4 rounded-2xl border border-accent/20 bg-ink-800/50 px-6 py-5 sm:flex-row sm:gap-8" data-id="element-241">
            <div className="flex flex-col items-center" data-id="element-242">
              <div className="flex items-end gap-1.5" data-id="element-243">
                <span className="font-display text-4xl tracking-tight text-cyan-gradient" data-id="element-244">
                  4.9
                </span>
                <span className="pb-1 text-sm font-semibold text-silver/60" data-id="element-245">
                  / 5
                </span>
              </div>
              <Stars className="mt-1" data-id="element-246" />
            </div>
            <div className="hidden h-12 w-px bg-white/10 sm:block" aria-hidden="true" data-id="element-247" />
            <div className="flex items-center gap-2.5 text-center" data-id="element-248">
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-accent/10 text-accent ring-1 ring-accent/30" data-id="element-249">
                <UsersIcon className="h-5 w-5" aria-hidden="true" data-id="element-250" />
              </span>
              <div className="text-left" data-id="element-251">
                <p className="font-heading text-lg font-extrabold text-white" data-id="element-252">
                  +2,400 creadores
                </p>
                <p className="text-xs text-silver/60" data-id="element-253">
                  ya están ejecutando con esto
                </p>
              </div>
            </div>
          </div>
        </Reveal>

        {/* Testimonial cards */}
        <div className="mt-8 grid gap-6 sm:grid-cols-2 lg:grid-cols-3" data-id="element-254">
          {testimonials.map((t, i) => <Reveal key={t.name} delay={i % 3 * 0.1} data-id="element-255">
              <motion.figure whileHover={{
            y: -6
          }} transition={{
            type: 'spring',
            stiffness: 300,
            damping: 22
          }} className="flex h-full flex-col rounded-3xl border border-white/8 bg-ink-800/60 p-6 shadow-card" data-id="element-256">
                <div className="flex items-center justify-between" data-id="element-257">
                  <Stars data-id="element-258" />
                  <QuoteIcon className="h-6 w-6 text-accent/40" aria-hidden="true" data-id="element-259" />
                </div>
                <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-silver/80" data-id="element-260">
                  "{t.quote}"
                </blockquote>
                <figcaption className="mt-6 flex items-center gap-3 border-t border-white/8 pt-4" data-id="element-261">
                  <span className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-full font-heading text-sm font-extrabold ring-1 ${avatarStyles[i % avatarStyles.length]}`} data-id="element-262">
                    {t.initials}
                  </span>
                  <span data-id="element-263">
                    <span className="block text-sm font-semibold text-white" data-id="element-264">
                      {t.name}
                    </span>
                    <span className="block text-xs text-silver/60" data-id="element-265">
                      {t.role}
                    </span>
                  </span>
                </figcaption>
              </motion.figure>
            </Reveal>)}
        </div>
      </div>
    </section>;
}